import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { DEFAULT_LANGUAGE, enviroments } from 'utils/constants';

export const poisServiceApi = createApi({
  reducerPath: 'poisServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetPois: builder.query<any, any>({
      query: (language = DEFAULT_LANGUAGE) => 'poi/?locale=' + language,
    }),
    SearchPois: builder.query<any, any>({
      query: ({txt, language = DEFAULT_LANGUAGE}) => ({
        url: `/poi/search?txt=${txt}&locale=${language}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetPoisQuery, useLazySearchPoisQuery } = poisServiceApi;
